export enum CompanyData {
    COMPANY_NAME = 'BARBUSS Risk Seguros (Argentina) S.A.'
}